<template>
  <vxe-modal v-model="visible" :destroyOnClose="true" :loading="loading" :title="$t('title.itemPackMaintain')" show-footer size="mini" type="confirm" width="50%" @cancel="cancel" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="data" :rules="rules" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.itemNo')">
            <a-input v-model="data.item.no" :disabled="true"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.itemName')">
            <a-input v-model="data.item.name" :disabled="true"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.dataSource')" prop="dataSource">
            <a-select v-model="data.dataSource" :options="dataSources" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.specification')" prop="specification">
            <a-input v-model="data.specification" :disabled="data.dataSource!==4"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.uom')" prop="uom">
            <a-input v-model="data.uom"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.factor')" prop="factor">
            <a-input v-model="data.factor"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.innerFactor')" prop="innerFactor">
            <a-input v-model="data.innerFactor"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.length')" prop="dimension.length">
            <a-input v-model="data.dimension.length" :suffix="$t('col.uomOfDimension')" @change="onDimensionChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.width')" prop="dimension.width">
            <a-input v-model="data.dimension.width" :suffix="$t('col.uomOfDimension')" @change="onDimensionChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.height')" prop="dimension.height">
            <a-input v-model="data.dimension.height" :suffix="$t('col.uomOfDimension')" @change="onDimensionChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.volume')" prop="dimension.volume">
            <a-input v-model="data.dimension.volume" :suffix="$t('col.uomOfVolume')"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.weight')">
            <a-input v-model="data.weight" :suffix="$t('col.uomOfWeight')"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.barcode')">
            <a-input v-model="data.barcode"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.shape')" prop="shape">
            <a-select v-model="data.shape" :options="shapes" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.robotArmNumber')">
            <a-input v-model="data.ordinal"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.master')" :label-col="wrapperCol" :wrapper-col="labelCol">
            <vxe-switch v-model="data.master" size="mini"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.wrapping')" :label-col="wrapperCol" :wrapper-col="labelCol">
            <vxe-switch v-model="data.wrapping" size="mini"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.catchWeight')" :label-col="wrapperCol" :wrapper-col="labelCol">
            <vxe-switch v-model="data.catchWeight" size="mini"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.transportable')" :label-col="wrapperCol" :wrapper-col="labelCol">
            <vxe-switch v-model="data.transportable" size="mini"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoPalletization')" :label-col="wrapperCol" :wrapper-col="labelCol">
            <vxe-switch v-model="data.autoPalletization" size="mini"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>
<script>
import { findOne, save } from '@/api/Api'
import { message } from 'ant-design-vue'
import { Pack } from '@/api/dto/common/Pack'
import { Dimension } from '@/api/dto/valueobject/Dimension'

export default {
  name: 'PackEditor',
  data() {
    return {
      visible: false,
      loading: false,
      data: new Pack(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        specification: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        uom: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        factor: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        innerFactor: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'dimension.length': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'dimension.width': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'dimension.height': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'dimension.volume': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        shape: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  props: {
    dataSources: {
      type: Array,
      default: []
    },
    shapes: {
      type: Array,
      default: []
    }
  },
  methods: {
    onDimensionChange() {
      this.data.dimension.volume = this.data.dimension.length * this.data.dimension.width * this.data.dimension.height
    },
    volumeChange(value, column) {
      const reg = /^\d*\.?\d{0,5}$/
      if (this.data.item.isNew()) {
        message.error('商品为空，请检查')
        this.data.dimension = new Dimension({ height: 0, length: 0, width: 0, volume: 0 })
      } else {
        if (column === 'length') {
          if (!value.match(reg)) {
            message.error('请输入数字')
            this.data.dimension.volume = 0
          } else if (parseFloat(value) > 0) {
            this.data.dimension.volume = this.data.dimension.length * this.data.dimension.width * this.data.dimension.height
          }

        } else if (column === 'width') {
          if (!value.match(reg)) {
            message.error('请输入数字')
            this.data.dimension.volume = 0
          } else if (parseFloat(value) > 0) {
            this.data.dimension.volume = this.data.dimension.length * this.data.dimension.width * this.data.dimension.height
          }
        } else if (column === 'height') {
          if (!value.match(reg)) {
            message.error('请输入数字')
            this.data.dimension.volume = 0
          } else if (parseFloat(value) > 0) {
            this.data.dimension.volume = this.data.dimension.length * this.data.dimension.width * this.data.dimension.height
          }
        }
      }
    },
    add(item) {
      this.visible = true
      this.data = new Pack()
      this.data.available = true
      this.data.item = item
      this.data.dataSource = 4
    },
    edit(id, copy) {
      this.visible = true
      this.loading = true
      findOne('packFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.data = new Pack(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const data = this.data.toJSONObject()
      save('packPersister', data).then(res => {
        if (res.success) {
          this.data = new Pack(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.cancel()
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>